import { render, staticRenderFns } from "./ModalCreateNewUserCrm.vue?vue&type=template&id=3a8ed50a&scoped=true&"
import script from "./ModalCreateNewUserCrm.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewUserCrm.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateNewUserCrm.vue?vue&type=style&index=0&id=3a8ed50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ed50a",
  null
  
)

export default component.exports